import {
  INPUT_ACTION,
  INPUT_CLOSE_PANEL,
  INPUT_DOWN,
  INPUT_LEFT,
  INPUT_OPEN_DEBUG_PANEL,
  INPUT_OPEN_BUILD_MENU,
  INPUT_OPEN_INVENTORY,
  INPUT_OPEN_TECH_TREE,
  INPUT_RIGHT,
  INPUT_UP,
  type Input,
} from '../contract.js';

export const PREVENT_KEYS = new Set([
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  ' ',
  'Space',
  'Enter',
  'Escape',
  'KeyA',
  'KeyB',
  'KeyD',
  'KeyE',
  'KeyF',
  'KeyI',
  'KeyS',
  'KeyT',
  'KeyV',
  'KeyW',
  'KeyX',
  'Digit1',
  'Digit2',
  'Digit3',
  'Digit4',
]);

export type MenuDirection = 'up' | 'right' | 'down' | 'left';

export function heldMaskForKey(event: KeyboardEvent): number {
  switch (event.code) {
    case 'ArrowLeft':
    case 'KeyA':
      return INPUT_LEFT;
    case 'ArrowRight':
    case 'KeyD':
      return INPUT_RIGHT;
    case 'ArrowUp':
    case 'KeyW':
      return INPUT_UP;
    case 'ArrowDown':
    case 'KeyS':
      return INPUT_DOWN;
    default:
      return 0;
  }
}

export function isActionKey(event: KeyboardEvent): boolean {
  return event.code === 'Space' || event.code === 'Enter' || event.code === 'KeyE';
}

export function queuedMaskForKey(event: KeyboardEvent): number {
  switch (event.code) {
    case 'Escape':
      return INPUT_CLOSE_PANEL;
    case 'Space':
    case 'Enter':
    case 'KeyE':
      return INPUT_ACTION;
    case 'KeyI':
      return INPUT_OPEN_INVENTORY;
    case 'KeyV':
      return INPUT_OPEN_BUILD_MENU;
    case 'KeyT':
      return INPUT_OPEN_TECH_TREE;
    case 'KeyB':
      return INPUT_OPEN_DEBUG_PANEL;
    default:
      return 0;
  }
}

export function buildCommandForKey(event: KeyboardEvent): Input['buildCommand'] | null {
  switch (event.code) {
    case 'Digit1':
      return 'recycler';
    case 'Digit2':
      return 'storage';
    case 'Digit3':
      return 'gatherer';
    case 'Digit4':
      return 'carrier_drone';
    default:
      return null;
  }
}

export function techCommandForKey(event: KeyboardEvent): Input['techCommand'] | null {
  switch (event.code) {
    case 'Digit1':
      return 'gather_speed';
    case 'Digit2':
      return 'movement_speed';
    case 'Digit3':
      return 'gatherer';
    case 'Digit4':
      return 'carrier_drone';
    default:
      return null;
  }
}

export function itemCommandForKey(event: KeyboardEvent): Input['itemCommand'] | null {
  return null;
}

export function toolCommandForKey(event: KeyboardEvent): Input['toolCommand'] | null {
  switch (event.code) {
    case 'Digit1':
      return 'grenade';
    case 'Digit2':
      return 'flamethrower';
    default:
      return null;
  }
}

export function debugCommandForKey(event: KeyboardEvent): Input['debugCommand'] | null {
  switch (event.code) {
    case 'Digit1':
      return 'grantTechPoint';
    case 'Digit2':
      return 'grantScrap';
    case 'Digit3':
      return 'grantPlastic';
    case 'Digit4':
      return 'grantGlass';
    case 'Digit5':
      return 'grantBiomass';
    case 'Digit6':
      return 'grantAllResources';
    default:
      return null;
  }
}

export function panelCommandForKey(event: KeyboardEvent): Input['panelCommand'] | null {
  switch (event.code) {
    case 'KeyT':
      return 'depositAll';
    case 'KeyX':
      return 'collectOutput';
    default:
      return null;
  }
}

export function panelCommandIndex(command: NonNullable<Input['panelCommand']>): number {
  return ['depositSelected', 'depositAll', 'collectOutput', 'removeBuilding', 'close'].indexOf(command);
}

export function menuNavigateForKey(event: KeyboardEvent): MenuDirection | null {
  switch (event.code) {
    case 'KeyW':
    case 'ArrowUp':
      return 'up';
    case 'KeyD':
    case 'ArrowRight':
      return 'right';
    case 'KeyS':
    case 'ArrowDown':
      return 'down';
    case 'KeyA':
    case 'ArrowLeft':
      return 'left';
    default:
      return null;
  }
}
